import { useQuery } from '@apollo/client'
import { graphql } from '../../gql'

const ListCampaigns = graphql(`
  query ListCampaigns {
    brands {
      id
      title
      rawStr
      campaigns(limit: 20) {
        items {
          id
          title
          description
          campaignPitch
          pitchHook
          hookStrength
          pitchTopic
          journalistSearchTerms
          rawStr
          createdAt
          updatedAt
        }
      }
    }
  }
`)

export const BrandPage = () => {
  const { data, loading, error } = useQuery(ListCampaigns)
  if (loading) return <p>Loading...</p>
  if (error) return <p>Error :(</p>
  return (
    <div>
      <h1 className='underline'>Hello World!</h1>
      {data?.brands.map(brand => (
        <div key={brand.id}>
          <h2>{brand.title}</h2>
          {/* <pre>{JSON.stringify(JSON.parse(campaign.rawStr ?? '{}'), null, 2)}</pre> */}
          {brand.campaigns.items.map(campaign => (
            <div key={campaign.id} className='inline-block'>
              <h3>{campaign.title}</h3>
              <p>{campaign.description}</p>
              <pre>{JSON.stringify(JSON.parse(campaign.rawStr ?? '{}'), null, 2)}</pre>
            </div>
          ))}
        </div>
      ))}
    </div>
  )
}